module.exports = [{
      plugin: require('../node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"linkImagesToOriginal":false,"maxWidth":590},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Boren 觀點","short_name":"Boren 觀點","start_url":"/","background_color":"#00A1CC","theme_color":"#00A1CC","display":"minimal-ui","icon":"src/images/boren_logo.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"e23d67251ac442a9307c86dc4e9ddd62"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
